import { string, object } from 'yup';

const schema = object({
  question: string().required('Question is required'),
  sectionType: string().required('Section is required')
});

export default { create: schema, edit: schema };
